<template>
  <b-overlay
    :show="loader.formulario"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <!-- titulo -->
      <b-row>
        <b-col
          cols="12"
        >
          <b-media class="mb-2">
            <template #aside>
              <b-avatar
                ref="previewEl"
                :src="userData.avatar"
                :text="avatarText(userData.nombreCompleto)"
                size="30px"
                rounded
              />
            </template>
            <h4 class="mb-1">
              {{ userData.nombreCompleto }}
            </h4>
            <p> {{ userData.persona[0].email }} </p>
          </b-media>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="4"
          class="text-center"
        >
          <b-card
            no-body
          >
            <div class="d-flex text-primary mx-2">
              <feather-icon
                icon="UserIcon"
                size="14"
              />
              <h6 class="mb-0 ml-50  text-primary">
                Alumno
              </h6>
            </div>
            <span
              v-if="userData .matricula !=false"
              class="text-primary align-text-top"
            >Matricula
              {{ userData .matricula }}
            </span>
          </b-card>
        </b-col>
        <b-col
          cols="4"
        >
          <b-card no-body>
            <div class="d-flex text-primary mx-2">
              <feather-icon
                icon="UsersIcon"
                size="14"
              />
              <h6 class="mb-0 ml-50 text-primary">
                Grupos
              </h6>
            </div>
            <b-list-group
              class="w-100 px-5"
              flush
            >
              <b-list-group-item
                v-for="grupos in userData.grupos"
                :key="grupos.grupo"
                :variant="grupos.variant"
                class="d-flex"
              >
                <small
                  :class="`text-${resolveUserGrupoVariant(grupos.grupo)}`"
                  class="align-text-top"
                >{{ grupos.grupo }}</small>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
        <b-col
          cols="4"
        >
          <b-card
            v-if="userData.roles.length!=0"
            no-body
          >
            <div class="d-flex text-primary mx-2">
              <feather-icon
                icon="LockIcon"
                size="14"
              />
              <h6 class="mb-0 ml-50 text-primary">
                Roles
              </h6>
            </div>
            <b-list-group
              class="w-100 px-5"
              flush
            >
              <b-list-group-item
                v-for="rolesv in userData.roles"
                :key="rolesv.rol"
                :variant="rolesv.variant"
              >
                <feather-icon
                  v-if="userData.roles[0].rol!=null"
                  :icon="resolveUserrolIcon(rolesv.rol)"
                  size="14"
                  class="mr-50"
                  :class="`text-${resolveUserrolVariant(rolesv.rol)}`"
                />
                <div
                  v-if="userData.roles[0].rol==null"
                >
                  <feather-icon
                    icon="AlertTriangleIcon"
                    size="24"
                    class="mr-50 text-danger"
                  />
                  <small> Cuidado, este usuario está dentro de un grupo diferente al de alumnos, debe de llevar algún rol.
                  </small>
                </div>
                <small
                  class="align-text-top"
                  :class="`text-${resolveUserrolVariant(rolesv.rol)}`"
                >{{ rolesv.rol }}
                </small>
                <small
                  v-if="rolesv.rol_activo===0"
                  class="align-text-top"
                >Alguna vez fue {{ rolesv.rol }}<br>(cuenta con un historial en el sistema, por el momento, este rol está desactivado)</small>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
      <editar-usuario-grupos
        :is-edit-grupos-sidebar-active.sync="isEditGruposSidebarActive"
        :cuenta-data="grupoOne"
        :user-data="userData.grupos"
      />
      <editar-usuario-roles
        :is-edit-roles-sidebar-active.sync="isEditRolesSidebarActive"
        :user-data="userData"
      />

      <!-- cuentas TABLE -->
      <b-card
        no-body
        class="border"
      >
        <div class="d-flex mt-2 text-primary m-2">
          <feather-icon
            icon="UserIcon"
            size="19"
          />
          <h4 class="mb-0 ml-50 text-primary">
            Cuentas
          </h4>
        </div>
        <validation-observer ref="simpleRules">
          <b-form class="mt-1">
            <b-table
              ref="table"
              striped
              responsive
              primary-key
              :items="userData.cuentas"
              class="mb-0"
              :fields="tableColumns"
            >
              <template #cell(cuenta)="data">
                <!-- Nombre usuario -->
                <b-col
                  cols="12"
                >
                  <b-form-group
                    label="Usuario"
                    label-for="usuario"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="usuario"
                      rules="required|alpha|min:3|max:45"
                    >
                      <b-input-group>
                        <b-form-input
                          v-model="data.item.cuenta"
                          :state="errors.length > 0 ? false:null"
                          autocomplete="off"
                          :disabled="data.item.deshabilita"
                        />
                        <b-input-group-append>
                          <b-button
                            variant="outline-primary"
                            @click="clickEditar(data.item)"
                          >
                            <feather-icon
                              :icon="returnIcon(data.item.deshabilita)"
                            />
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </template>
              <template #cell(estado)="data">
                <b-form-checkbox
                  v-model="data.item.estado"
                  unchecked-value="inactivo"
                  value="activo"
                  switch
                  @change="submitForm(data.item)"
                >{{ data.item.estado }}</b-form-checkbox>
              </template>
              <!-- Column: Actions  -->
              <template #cell(opciones)="data">
                <b-button
                  variant="border-transparent"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  size="sm"
                  @click.prevent="editargrupos
                    ({
                      id_usuario: data.item.id_usuario,
                    })"
                >
                  <feather-icon
                    :id="`grupos-row-${data.index}-editar`"
                    icon="UsersIcon"
                    class="text-primary"
                  />
                </b-button>
                <b-tooltip
                  title="Editar grupos"
                  :target="`grupos-row-${data.index}-editar`"
                  placement="lefttop"
                />
                <b-button
                  variant="border-transparent"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  size="sm"
                  @click.prevent="editarroles()"
                >
                  <feather-icon
                    :id="`roles-row-${data.index}-editar`"
                    class="text-primary"
                    icon="LockIcon"
                  />
                </b-button>
                <b-tooltip
                  title="Editar roles"
                  :target="`roles-row-${data.index}-editar`"
                  placement="lefttop"
                />
              </template>
            </b-table>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BButton, BListGroup, BListGroupItem,
  BMedia, BAvatar, BFormGroup, BTable, BCard, BForm, BFormCheckbox, BFormInput,
  BInputGroup, BInputGroupAppend, BOverlay, BTooltip,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { postData } from '@core/utils/http/general'
import store from '@/store'
import {
  configTableUsuarios,
} from '@/views/campus/usuarios/useUsuarios'
import EditarUsuarioGrupos from './EditarUsuarioGrupos.vue'
import EditarUsuarioRoles from './EditarUsuarioRoles.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BMedia,
    BAvatar,
    BFormGroup,
    BTable,
    BCard,
    BListGroup,
    BListGroupItem,
    BForm,
    BFormCheckbox,
    EditarUsuarioGrupos,
    EditarUsuarioRoles,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BTooltip,

  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // FORMS
      fmroles: {
        rol: null,
      },
      fmcuenta: {
        id: null,
        cuenta: null,
        activo: null,
      },
      grupoOne: {},
      habilitarEdicion: false,
      // EXTRA
      counter: 1,
      loader: {
        formulario: false,
      },
    }
  },
  setup() {
    const { resolveUserestadoVariant } = configTableUsuarios()
    const { resolveUserGrupoVariant } = configTableUsuarios()
    const { estadoOptions } = configTableUsuarios()
    const { rolOptions } = configTableUsuarios()
    const { resolveUserrolVariant } = configTableUsuarios()
    const { resolveUserrolIcon } = configTableUsuarios()
    const isEditGruposSidebarActive = false
    const isEditRolesSidebarActive = false
    // Table Handlers
    const tableColumns = [
      { key: 'cuenta' },
      { key: 'estado' },
      { key: 'opciones' },
    ]
    return {
      // resolveUserRoleVariant,
      avatarText,
      estadoOptions,
      resolveUserestadoVariant,
      resolveUserrolVariant,
      resolveUserGrupoVariant,
      resolveUserrolIcon,
      rolOptions,
      tableColumns,
      isEditGruposSidebarActive,
      isEditRolesSidebarActive,
    }
  },
  beforeMount() {
    this.userData.cuentas.forEach((element, index) => {
      this.userData.cuentas[index].deshabilita = true
      this.userData.cuentas[index].indice = index
    })
  },
  methods: {
    agregarRol(rol) {
      let bandera = false
      if (rol === null)bandera = true
      this.userData.roles.forEach(element => {
        if (element.rol === rol) bandera = true
      })
      if (bandera === false) this.userData.roles.push({ rol, variant: 'danger' })
    },
    editargrupos(datos) {
      this.grupoOne = datos
      this.isEditGruposSidebarActive = true
    },
    editarroles() {
      this.isEditRolesSidebarActive = true
    },
    returnIcon(dato) {
      return dato === false ? 'SaveIcon' : 'Edit3Icon'
    },
    clickEditar(dato) {
      const i = dato.indice
      if (dato.deshabilita === true) {
        this.userData.cuentas[i].deshabilita = false
      } else {
        this.userData.cuentas[i].deshabilita = true
        this.validationForm(dato)
      }
      this.$refs.table.refresh()
    },
    validationForm(dato) {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitForm(dato)
        }
      })
    },
    submitForm(dato) {
      if (this.counter <= 10) {
        const params = new FormData()
        this.loader.formulario = true
        this.fmcuenta.cuenta = dato.cuenta
        this.fmcuenta.id = dato.id_usuario
        this.fmcuenta.activo = dato.estado === 'activo' ? 1 : 0
        params.append('task', 'wsusuarios')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('token', store.state.cuenta.session.token)
        params.append('action', 3)
        params.append('data', JSON.stringify(this.fmcuenta))
        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              this.registroExitoso()
            } else {
              this.$bvToast.toast(response.data.message, {
                title: `${response.data.status} - Error al realizar post`,
                variant: 'danger',
                solid: true,
              })
              // this.tbl = response.data.tbl
            }
            this.loader.formulario = false
          })
          .catch(err => {
            this.loader.formulario = false
            this.$bvToast.toast(err, {
              title: 'Error en solicitud',
              variant: 'danger',
              solid: true,
            })
          })
        this.counter += 1
      } else {
        this.$bvToast.toast('La página ha expirado, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    registroExitoso() {
      this.$swal({
        title: '<b>Registro modificado</b>',
        html: '',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
